export enum BasicAttrTextEnum {
  atk = '攻击',
  crt = '暴击率',
  crtd = '暴击伤害',
  heat = '破防',
  hr = '命中率',
  atksp = '攻击速度',
  voidDef = '抗魔值',
  ad = '全伤害加成',
  windDa = '风伤害加成',
  fireDa = '火伤害加成',
  waterDa = '水伤害加成',
  soilDa = '土伤害加成',
  windIndDa = '独立风伤害加成',
  fireIndDa = '独立火伤害加成',
  waterIndDa = '独立水伤害加成',
  soilIndDa = '独立土伤害加成',
  mp = '魔法值',
  mpRegen = '魔法回复值',
  skillDa = '技能伤害加成',
  cda = '冷却缩减加成',
  sce = '魔法消耗降低',
  igFireDef = '忽略火抗性',
  igWaterDef = '忽略水抗性',
  igWindDef = '忽略风抗性',
  igSoilDef = '忽略土抗性',
  undeadDa = '对不死族伤害加成',
  orcDa = '对兽族伤害加成',
  caveDa = '对穴居族伤害加成',
  elDa = '对元素族伤害加成',
  elfDa = '对精灵伤害加成',
  dmDa = '对恶魔伤害加成',
  faeDa = '对妖精伤害加成',
  mzDa = '对泥泽族伤害加成',
  allSkillGrow = '全技能等级加成',
  fireSkillGrow = '火系技能等级加成',
  waterSkillGrow = '水系技能等级加成',
  windSkillGrow = '风系技能等级加成',
  soilSkillGrow = '土系技能等级加成',
  skillGrow = '技能等级加成',
}

export enum EquipPriceEnum {
  normal = 100,
  race = 200,
  epic = 400,
  unique = 800,
  legend = 1000,
  antiquity = 1000,
  peerless = 2000,
  darkGold = 50000,
  myth = 100000,
  supreme = 200000,
}

export enum RaceEnum {
  undead = 1,
  orc = 2,
  cave = 3,
  el = 4,
  elf = 5,
  dm = 6,
  fae = 7,
  mz = 8,
}

export enum SkillPriceEnum {
  normal = 20000,
  race = 40000,
  epic = 80000,
  legend = 200000,
  antiquity = 500000,
}
